import * as React from 'react';

import { IconProps } from './IconProps.types';

function SvgStarRating16(props: IconProps) {
  const { title, ...rest } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={110.761}
      height={16}
      viewBox='0 0 110.761 16'
      {...rest}
    >
      {title && <title>{title}</title>}
      <path d='M7 1a.507.507 0 01.909 0l1.937 3.926 4.334.63c.415.06.581.57.28.863l-3.135 3.057.74 4.315a.507.507 0 01-.735.534L7.454 12.29 3.58 14.326a.507.507 0 01-.735-.535l.74-4.315L.448 6.419a.507.507 0 01.281-.864l4.333-.63L7 1zM31 1a.507.507 0 01.909 0l1.937 3.926 4.334.63c.415.06.581.57.28.863l-3.135 3.057.74 4.315a.507.507 0 01-.735.534l-3.876-2.036-3.875 2.037a.507.507 0 01-.735-.535l.74-4.315-3.136-3.057a.507.507 0 01.281-.864l4.333-.63L31 1zM55 1a.507.507 0 01.909 0l1.937 3.926 4.334.63c.415.06.581.57.28.863l-3.135 3.057.74 4.315a.507.507 0 01-.735.534l-3.876-2.036-3.875 2.037a.507.507 0 01-.735-.535l.74-4.315-3.136-3.057a.507.507 0 01.281-.864l4.333-.63L55 1zM79 1a.507.507 0 01.909 0l1.937 3.926 4.334.63c.415.06.581.57.28.863l-3.135 3.057.74 4.315a.507.507 0 01-.735.534l-3.876-2.036-3.875 2.037a.507.507 0 01-.735-.535l.74-4.315-3.136-3.057a.507.507 0 01.281-.864l4.333-.63L79 1zM103 1a.507.507 0 01.909 0l1.937 3.926 4.334.63c.415.06.581.57.28.863l-3.135 3.057.74 4.315a.507.507 0 01-.735.534l-3.876-2.036-3.875 2.037a.507.507 0 01-.735-.535l.74-4.315-3.136-3.057a.507.507 0 01.281-.864l4.333-.63L103 1z' />
    </svg>
  );
}

export default SvgStarRating16;
